import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { axios as axios2 } from "../../../shared/lib/axios";
import { v4 as uuidv4 } from "uuid";
import _cookies from "../../../shared/utils/_cookies";

export const uploadPandaVideo = async (data) => {
  const id = uuidv4();
  const file = data.file;

  // Etapa 1 — POST para criar a sessão TUS (corpo vazio, sem Content-Type de octets)
  const createResponse = await axios.post(
    "https://uploader-us01.pandavideo.com.br/files",
    null,
    {
      headers: {
        "Tus-Resumable": "1.0.0",
        "Upload-Length": `${file.size}`,
        "Content-Length": "0",
        "Upload-Metadata": `authorization ${btoa(
          "panda-289d6e06c16b72e71f3245f115d65a44db7e50d924628c490936c771d8addce6",
        )}, filename ${btoa(unescape(encodeURIComponent(data.title)))}, video_id ${btoa(id)}, folder_id ${btoa(
          data.folderId,
        )}`,
      },
    },
  );

  // Etapa 2 — PATCH para enviar os bytes do arquivo
  const uploadUrl =
    createResponse.headers["location"] || createResponse.headers["Location"];

  if (!uploadUrl) {
    throw new Error(
      "PandaVideo não retornou URL de upload (header Location ausente)",
    );
  }

  await axios.patch(uploadUrl, file, {
    headers: {
      "Tus-Resumable": "1.0.0",
      "Upload-Offset": "0",
      "Content-Length": `${file.size}`,
      "Content-Type": "application/offset+octet-stream",
    },
  });

  const res2 = await axios2.apiCadernoVirtual.post("/video-service/video", {
    name: data.title,
    userId:
      _cookies.getItem("auth").user?.profile?.isProfessor?.ID ||
      encodeURIComponent(_cookies.getItem("auth").user.nome),
    videoId: id,
    albumId: data.albumId,
    folderId: data.folderId,
  });
  return res2;
};

export const useUploadPandaVideo = ({ config } = {}) => {
  return useMutation({ ...config, mutationFn: uploadPandaVideo });
};
